import { TDocument } from "../types";
import { date2DDMMMMMYYYString } from "../../lib/textutils";

export const getSelectionHtml = (): string | null => {
  const selection = document.getSelection();
  if (!selection || selection.rangeCount === 0) return null;
  const range = selection.getRangeAt(0);
  if (range.collapsed) return null;
  const ancestor = range.commonAncestorContainer;
  const ancestorEl = ancestor.nodeType === Node.ELEMENT_NODE
    ? (ancestor as Element)
    : ancestor.parentElement;
  if (!ancestorEl || !ancestorEl.closest('#document-body')) return null;
  const div = document.createElement('div');
  div.appendChild(range.cloneContents());
  return div.outerHTML;
};

export const titleForDoc = (doc: TDocument, isFragment: boolean): string => {
  const actionString = doc.revdata.rev_type === 'Publicare'
    ? doc.revdata.rev_number === 1 ? 'Publicare' : 'Republicare'
    : 'Modificare';
  const formattedRevDate = date2DDMMMMMYYYString(new Date(doc.revdata.rev_date));
  return `${doc.newtype} ${doc.issuers[0].issuer_nr}|${doc.issue_year} - ${actionString} ${formattedRevDate}${isFragment ? ' (fragment)' : ''}`;
};
